<template>
  <div class="o-focus o-tabs__tab--fixed-head">
    <div class="o-panel__header" v-my-fixed-title>
      <h3 class="o-panel__title">Delivering for our customers</h3>
    </div>

    <my-slider ref="slider">
      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body">
          <div class="o-focus__intro">
            <p>Most of the time, we deliver electricity to our customers, who may be unaware of UK Power Networks’ existence. Sometimes, though, things go wrong, or customers have a particular request. Those are the times when our service becomes apparent. Our customers’ satisfaction is important to us; we take our responsibility to provide the service our customers want very seriously, and to address their concerns quickly and effectively. We pay particular attention to the opinion of our customers who are vulnerable as a consequence of a variety of factors such as ill health, disability or fuel poverty.</p>
          </div>

          <div class="o-link__btn-group">
            <my-download-button :section="'focus-customer-satisfaction'"></my-download-button>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full">

          <!-- Accordian tabs -->
          <my-accordians @tab-changed="tabHasChanged">

            <my-accordian :title="'UK Power Networks Average'">
              <div class="o-media--focus">
                <div class="o-media__data">
                  <figure class="o-media__chart o-chart">
                    <figcaption class="o-chart__caption">UK Power Networks Average</figcaption>
                    <my-chart :color="['red']" :file="'customer-average'" :skew="70" :replace-na="true"></my-chart>
                  </figure>
                  <p class="u-footnote">The figures for 2010/11 are not available as Ofgem began measuring customer satisfaction in this format in 2011/12.</p>
                </div>
                <div class="o-media__text">
                  <figure class="o-media__kpi o-kpi">
                    <figcaption class="o-kpi__caption o-kpi__caption--large">Our highest ever customer satisfaction score</figcaption>
                  </figure>
                  <p>Ofgem measures customer satisfaction scores across the industry, at UK Power Networks this year’s the average score across the three licence areas of 86% is our best ever, continuing the rising trend since 2011.</p>
                </div>
              </div>
            </my-accordian>

            <my-accordian :title="'East'">
              <div class="o-media--focus">
                <div class="o-media__data">
                  <figure class="o-media__chart o-chart">
                    <figcaption class="o-chart__caption">East</figcaption>
                    <my-chart :color="['red']" :file="'customer-east'" :skew="70" :replace-na="true"></my-chart>
                  </figure>
                  <p class="u-footnote">The figures for 2010/11 are not available as Ofgem began measuring customer satisfaction in this format in 2011/12.</p>
                </div>
                <div class="o-media__text">
                  <figure class="o-media__kpi o-kpi">
                    <figcaption class="o-kpi__caption o-kpi__caption--large">Our highest ever customer satisfaction score</figcaption>
                  </figure>
                  <p>Ofgem measures customer satisfaction scores across the industry, at UK Power Networks this year’s the average score across the three licence areas of 86% is our best ever, continuing the rising trend since 2011.</p>
                </div>
              </div>
            </my-accordian>

            <my-accordian :title="'London'">
              <div class="o-media--focus">
                <div class="o-media__data">
                  <figure class="o-media__chart o-chart">
                    <figcaption class="o-chart__caption">London</figcaption>
                    <my-chart :color="['red']" :file="'customer-london'" :skew="70" :replace-na="true"></my-chart>
                  </figure>
                  <p class="u-footnote">The figures for 2010/11 are not available as Ofgem began measuring customer satisfaction in this format in 2011/12.</p>
                </div>
                <div class="o-media__text">
                  <figure class="o-media__kpi o-kpi">
                    <figcaption class="o-kpi__caption o-kpi__caption--large">Our highest ever customer satisfaction score</figcaption>
                  </figure>
                  <p>Ofgem measures customer satisfaction scores across the industry, at UK Power Networks this year’s the average score across the three licence areas of 86% is our best ever, continuing the rising trend since 2011.</p>
                </div>
              </div>
            </my-accordian>

            <my-accordian :title="'South East'">
              <div class="o-media--focus">
                <div class="o-media__data">
                  <figure class="o-media__chart o-chart">
                    <figcaption class="o-chart__caption">South East</figcaption>
                    <my-chart :color="['red']" :file="'customer-south-east'" :skew="70" :replace-na="true"></my-chart>
                  </figure>
                  <p class="u-footnote">The figures for 2010/11 are not available as Ofgem began measuring customer satisfaction in this format in 2011/12.</p>
                </div>
                <div class="o-media__text">
                  <figure class="o-media__kpi o-kpi">
                    <figcaption class="o-kpi__caption o-kpi__caption--large">Our highest ever customer satisfaction score</figcaption>
                  </figure>
                  <p>Ofgem measures customer satisfaction scores across the industry, at UK Power Networks this year’s the average score across the three licence areas of 86% is our best ever, continuing the rising trend since 2011.</p>
                </div>
              </div>
            </my-accordian>

          </my-accordians>

        </div>
      </my-slide>

    </my-slider>

  </div>
</template>

<script>
import MyChart from '@/components/standard/my-chart'
import { MyAccordians, MyAccordian } from '@/components/standard/my-accordian'
import MyDownloadButton from '@/components/standard/my-download-button'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import { MyFixedTitle } from '@/directives/my-fixed-title.js'

export default {
  name: 'my-focus-customer',
  components: {
    MyChart,
    MyAccordians,
    MyAccordian,
    MyDownloadButton,
    MySlider,
    MySlide
  },
  directives: {
    MyFixedTitle
  },
  methods: {
    tabHasChanged () {
      this.$refs.slider.resizeFlkty()
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyFocusCustomer.vue?c3080d66